import { Quote } from "lucide-react";

export default function TestimonialsSection({ testimonials, active, setActive }) {
  if (!testimonials.length) return null;
  const t = testimonials[active];

  return (
    <section className="section-pad bg-forest text-white relative overflow-hidden">
      <div className="absolute -top-20 -right-20 h-80 w-80 rounded-full bg-clay/15 blur-3xl" />
      <div className="container-x relative">
        <div className="max-w-2xl">
          <p className="eyebrow text-clay-light">Real stories</p>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl md:text-5xl leading-tight">Transformations, not testimonials.</h2>
        </div>

        <div className="mt-10 md:mt-14 grid lg:grid-cols-5 gap-8 md:gap-10 items-center">
          <div className="lg:col-span-2">
            <div className="relative aspect-square rounded-[1.5rem] md:rounded-[2rem] overflow-hidden border border-white/10 max-w-md mx-auto lg:max-w-none">
              <img src={t.image} alt={t.name} className="h-full w-full object-cover transition-all duration-700" />
            </div>
          </div>
          <div className="lg:col-span-3">
            <Quote className="h-8 w-8 md:h-10 md:w-10 text-clay-light" strokeWidth={1.5} />
            <blockquote className="mt-3 md:mt-4 font-serif text-xl md:text-2xl lg:text-3xl leading-snug">"{t.quote}"</blockquote>
            <div className="mt-5 md:mt-6">
              <div className="font-medium">{t.name}, {t.age}</div>
              <div className="text-sm text-white/70">{t.location} · {t.program}</div>
              <div className="mt-2 inline-block rounded-full bg-clay px-4 py-1.5 text-sm font-medium">{t.result}</div>
            </div>
            <div className="mt-6 md:mt-8 flex gap-2" data-testid="testimonial-dots">
              {testimonials.map((tm, i) => (
                <button
                  key={tm.name}
                  data-testid={`testimonial-dot-${i}`}
                  onClick={() => setActive(i)}
                  className={`h-1.5 rounded-full transition-all ${i === active ? "w-10 bg-clay" : "w-4 bg-white/25"}`}
                  aria-label={`Go to testimonial ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
